import { usePanTiltVideoCameraMutation, useVideoCameraZoomMutation } from '@kinetic-ui/data-layer';
import { useCallback } from 'react';

export const useCameraPTZ = () => {
  const [panTiltCameraMutation] = usePanTiltVideoCameraMutation();
  const [cameraZoomMutation] = useVideoCameraZoomMutation();

  const panTiltCamera = useCallback(
    (cameraId: string, panSpeed: number, tiltSpeed: number) => {
      if (
        panSpeed === undefined ||
        panSpeed === null ||
        tiltSpeed === undefined ||
        tiltSpeed === null ||
        isNaN(panSpeed) ||
        isNaN(tiltSpeed)
      ) {
        return;
      }
      panTiltCameraMutation({
        variables: {
          cameraPanTiltInput: {
            cameraId,
            panSpeed,
            tiltSpeed,
          },
        },
      });
    },
    [panTiltCameraMutation]
  );

  const cameraZoom = useCallback(
    (cameraId: string, zoomSpeed: number) => {
      if (zoomSpeed === undefined || zoomSpeed === null || isNaN(zoomSpeed)) {
        return;
      }
      cameraZoomMutation({
        variables: {
          cameraZoomInput: {
            cameraId,
            zoomSpeed,
          },
        },
      });
    },
    [cameraZoomMutation]
  );

  return {
    cameraZoom,
    panTiltCamera,
  };
};
